module.exports = __webpack_public_path__ + "img/banner.0b6a9367.png";